/**
 * Samweb WebClient
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CallHistoryForUserRequestData } from '../model/callHistoryForUserRequestData';
import { CallHistoryForUserResponseData } from '../model/callHistoryForUserResponseData';
import { CallHistoryQueryRequestData } from '../model/callHistoryQueryRequestData';
import { CallHistoryResponseData } from '../model/callHistoryResponseData';
import { ChangeCallHistoryProgressStateRequestData } from '../model/changeCallHistoryProgressStateRequestData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CallHistoryService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeCallHistoryProgressState(body?: ChangeCallHistoryProgressStateRequestData, observe?: 'body', reportProgress?: boolean): Observable<CallHistoryResponseData>;
    public changeCallHistoryProgressState(body?: ChangeCallHistoryProgressStateRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallHistoryResponseData>>;
    public changeCallHistoryProgressState(body?: ChangeCallHistoryProgressStateRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallHistoryResponseData>>;
    public changeCallHistoryProgressState(body?: ChangeCallHistoryProgressStateRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CallHistoryResponseData>('post',`${this.basePath}/api/call-history/call-history-progress-state`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallHistory(body?: CallHistoryQueryRequestData, observe?: 'body', reportProgress?: boolean): Observable<CallHistoryResponseData>;
    public getCallHistory(body?: CallHistoryQueryRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallHistoryResponseData>>;
    public getCallHistory(body?: CallHistoryQueryRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallHistoryResponseData>>;
    public getCallHistory(body?: CallHistoryQueryRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CallHistoryResponseData>('post',`${this.basePath}/api/call-history/call-history`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallHistoryForUser(body?: CallHistoryForUserRequestData, observe?: 'body', reportProgress?: boolean): Observable<CallHistoryForUserResponseData>;
    public getCallHistoryForUser(body?: CallHistoryForUserRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallHistoryForUserResponseData>>;
    public getCallHistoryForUser(body?: CallHistoryForUserRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallHistoryForUserResponseData>>;
    public getCallHistoryForUser(body?: CallHistoryForUserRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CallHistoryForUserResponseData>('post',`${this.basePath}/api/call-history/call-history-for-user`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
